module.exports = __webpack_public_path__ + "static/media/Ø2_3.8858f9f4.png";